






















































































































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { ApplicationChangeType} from '../fixed/ApplicationChangeType';
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
// 個別
import { loadingControlModule } from '../../store/modules/LoadingControl';

import workTypeList from '../components/WorkTypeConfirmList.vue';
Vue.component('variableWorkTypeList', workTypeList);

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationFormConstruction extends ApiAccessBase {
  // 処理状況
  protected statusValue: string = '';
  // 変更前
  protected variablecolsBefore: any = {};
  protected formDataBefore: any = {};

  // 拡張パネルの設定（検索条件）
  private exPanel: number[] = [];
  private exPanelBk: number[] = [];

  // 業者種別
  private traderType = applicationFormModule.GET_APP_TYPE;
  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/application_change/' + applicationFormModule.GET_APP_TYPE;

  private variableColNames: string[] = [];
  private GROUP_LAYOUT_ARRAY: string = Constants.GROUP_LAYOUT_ARRAY;

  private isOrderUser = supervisingModule.IS_ORDER_USER;
  private isUketukeDownload = false;

  /**
   * 初期化処理created
   */
  private created() {
    this.screenTitle = '変更申請登録確認';

    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;
    path = path + '/get';

    // APIアクセス
    this.apiAccess(path + '/before/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        this.variablecolsBefore = JSON.parse(JSON.stringify(this.variablecols));
        this.formDataBefore = JSON.parse(JSON.stringify(this.formData));
      }
      // APIアクセス 変更後
      return this.apiAccess(path + '/after/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_GET, false, false);
    }).then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        let panelIndex = 0;
        for (const variablecol of Object.keys(this.variablecols)) {
          if (variablecol !== 'local_info') {
            // パネル設定全オープン
            this.exPanel.push(panelIndex);
            panelIndex++;
            this.variableColNames.push(variablecol);
          }
        }
        this.exPanelBk = this.exPanel.concat();
        // 処理状況表示
        this.statusValue = '処理状況：' + this.formData.status;
        if (this.formData.status.substring(0, 3) !== '入力中') {
          this.isUketukeDownload = true;
        }
        // 受付整理票関連制御
        if (!this.colInfo.uksButton) {
          this.isUketukeDownload = true;
        }
      }
    });
  }

  /**
   * 申請書提出
   */
  private registAppForm() {

    let path = this.APP_PATH;
    path = path + '/submit/' + applicationFormModule.GET_TRADER_ID;

    // 登録
    this.apiAccess(path, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setIsSubmitEnd(true);
        // 排他解除前にメッセージ保持
        const successMessage = this.infoMessage;
        // 排他解除
        this.deleteExclusive();
        // 2023/10/10 [2023L-05] upd start
        //// 排他解除後にメッセージ格納
        //this.infoMessage = successMessage;
        // 2023/10/10 [2023L-05] upd end

        // 2023/10/10 [2023L-05] add start
        // 処理状況の更新のためデータを再取得
        path = this.APP_PATH;
        path = path + '/get';
        // APIアクセス
        this.apiAccess(path + '/before/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_GET, false, false)
        .then((result2) => {
          if (result2 === Constants.API_RESULT_SUCCES) {
            this.variablecolsBefore = JSON.parse(JSON.stringify(this.variablecols));
            this.formDataBefore = JSON.parse(JSON.stringify(this.formData));
          }
          // APIアクセス 変更後
          return this.apiAccess(path + '/after/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_GET, false, false);
        }).then((result2) => {
          if (result2 === Constants.API_RESULT_SUCCES) {
            // 処理状況の再表示
            this.statusValue = '処理状況：' + this.formData.status;
            // 排他解除前に保持したメッセージを格納
            this.infoMessage = successMessage;
          }
        });
        // 2023/10/10 [2023L-05] add end
      }
    });
    // 先頭へジャンプ
    this.hrefElement('af-const', -50);
  }

  /**
   * 戻るボタンの処理
   */
  private returnFunc() {
    if (this.isSubmitEnd()) {
      this.returnSearchOrMenu();
    } else {
      this.returnPrevious();
    }
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    router.push('appForm');
  }

  /**
   * 排他レコードの削除
   */
  private deleteExclusive() {
    const exclusiveDeletePath: string = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE;
    if (supervisingModule.CHECK_MODE_UPDATE) {
      this.apiAccess(exclusiveDeletePath + '/exclusive/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_POST, false, true)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          //継続申請時の前回データも解除
          if (applicationFormModule.IS_SET_BEFORE_TRADER_ID) {
            this.apiAccess(exclusiveDeletePath + '/exclusive/' + applicationFormModule.GET_BEFORE_TRADER_ID, Constants.API_METHOD_POST, false, true)
            .then((result2) => {
            });
          }
        }
      });
    }
  }
  /**
   * 検索画面or受注者メニュー画面に戻る
   */
  private returnSearchOrMenu() {
    applicationFormModule.moduleResetDetail();
    if (supervisingModule.IS_ORDER_USER) {
      router.push({name: applicationFormModule.GET_TRANSITION_SOURCE_SCREEN});
    } else {
      router.push('accepterMainMenu');
    }
  }

  private exPanelAllClose() {
    this.exPanel = [];
  }
  private exPanelAllOpen() {
    this.exPanel = this.exPanelBk.concat();
  }
  /**
   * 受付整理票印刷
   */
  private uketsukeDownload() {
    let path = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE;
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      path = path + '/uketsukehyo' + '/' + applicationFormModule.GET_TRADER_ID;
      this.apiAccessDownload(path);
      this.isUketukeDownload = true;
    }
  }
  private screenPrint() {
    // window.print();
    router.push('appFormConfirmChangePrint');
  }

  private isSubmitEnd() {
    return applicationFormModule.isSubmitEnd;
  }
}
